function playNotificationSound() {
  const context = new AudioContext();
  const oscillator = context.createOscillator();
  const gain = context.createGain();

  oscillator.frequency.value = 880;
  gain.gain.value = 0.04;
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start();
  gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.18);
  oscillator.stop(context.currentTime + 0.18);
  oscillator.onended = () => {
    void context.close();
  };
}

export function notifyIncomingMessage(
  text: string,
  title: string,
  options?: { sound?: boolean },
) {
  if (typeof window === 'undefined') {
    return;
  }

  if (options?.sound) {
    try {
      playNotificationSound();
    } catch {
      // Браузер может запретить звук до первого жеста.
    }
  }

  if (
    typeof Notification === 'undefined' ||
    Notification.permission !== 'granted'
  ) {
    return;
  }

  const body = text.replace(/\s+/g, ' ').trim().slice(0, 140);
  new Notification(title, { body });
}

export function requestNotificationPermission() {
  if (
    typeof Notification === 'undefined' ||
    Notification.permission !== 'default'
  ) {
    return;
  }

  void Notification.requestPermission();
}
